import { connect } from "react-redux";
import { getOrders, requestBackup } from "../../../actions";

import OrdersUserStyled from "./index";
const mapStateToProps = state => {
  return {
    allorders: state.allorders,
    export: state.export
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getOrders: () => dispatch(getOrders()),
    requestBackup: config => dispatch(requestBackup(config))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrdersUserStyled);
